<template>
    <div class="message-body">
        <div class="message-html pt-3">
            <div class="flex items-start mb-4 space-x-4">
                <div>
                    <avatar :user="competitor.user" class="w-14 h-14" />
                </div>
                <div v-if="!message.isAuthor" class="flex flex-col space-y-1">
                    <h3 class="font-medium">{{ competitor.user.tag }} has sent a challenge request.</h3>
                    <div><Link :href="post.url" :class="[!message.isAuthor ? 'text-blue-600' : 'text-white']" class="underline">Open Challenge</Link>. Do you approve or deny the request?</div>
                </div>
                <div v-if="message.isAuthor" class="flex flex-col space-y-1">
                    <h3 class="font-medium">Your challenge request has been sent.</h3>
                    <div>{{ competitor.user.tag }} accepts your <Link :href="post.url" :class="[!message.isAuthor ? 'text-blue-600' : 'text-white']" class="underline">challenge</Link>. Do you approve?</div>
                </div>
            </div>

            <div ref="verificationPhoto" :class="{ 'max-h-72 sm:max-h-128': !verificationPhotoExpanded }" class="verification-photo relative rounded-lg shadow overflow-hidden">
                <img @click="toggleVerificationPhotoSize" :src="competitor.verificationPhotoPath" alt="Challenge Request Selfie" />
                <button v-show="isOverflowing && !verificationPhotoExpanded" @click="toggleVerificationPhotoSize" class="absolute bottom-3 right-4 p-2 text-gray-500 hover:text-gray-700 bg-white bg-opacity-25 hover:bg-opacity-30 rounded shadow-sm" title="Expand">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                    </svg>
                </button>
            </div>
        </div>
        <div v-if="!message.isAuthor && competitor.approved === null" class="flex pt-2 space-x-4">
            <jet-button @click.native="approve" :processing="approveForm.processing" color="indigo" class="w-full" size="sm"> Approve </jet-button>
            <jet-button @click.native="deny" :processing="denyForm.processing" color="white" class="w-full" size="sm"> Deny </jet-button>
        </div>
        <div v-if="competitor.approved === 1" class="pt-2">
            <jet-button @click.prevent color="indigo" class="w-full pointer-events-none" size="sm">
                <span class="flex items-center space-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Approved</span>
                </span>
            </jet-button>
        </div>
        <div v-if="competitor.approved === 0" class="pt-2">
            <jet-button @click.prevent color="white" class="w-full pointer-events-none" size="sm">
                <span class="flex items-center space-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span>Denied</span>
                </span>
            </jet-button>
        </div>
    </div>
</template>

<script>
import JetButton from "@/Jetstream/Button"
import Tooltip from "@/Components/Tooltip"

export default {
    components: { Tooltip, JetButton },

    mounted() {
        setTimeout(() => {
            this.isOverflowing = this.$refs.verificationPhoto.scrollHeight > this.$refs.verificationPhoto.clientHeight || this.$refs.verificationPhoto.scrollWidth > this.$refs.verificationPhoto.clientWidth
        }, 500)
    },

    props: {
        message: {
            required: true,
            type: Object,
        },
    },

    computed: {
        competitor() {
            return this.message.messageables.competitor
        },
        post() {
            return this.message.messageables.post
        },
        user() {
            return this.message.messageables.user
        },
        routeParams() {
            return { post: this.post.id, competitorByUsername: this.competitor.user.username }
        },
    },

    data() {
        return {
            approveForm: this.$inertia.form({
                _method: "POST",
            }),
            denyForm: this.$inertia.form({
                _method: "POST",
            }),
            verificationPhotoExpanded: false,
            isOverflowing: null,
        }
    },

    methods: {
        approve() {
            this.approveForm.put(route("challenge.request.approve", this.routeParams), {
                onSuccess: () => this.$root.$emit("challengeRequestReviewed", "approved"),
                preserveScroll: true,
            })
        },
        deny() {
            this.denyForm.put(route("challenge.request.deny", this.routeParams), {
                onSuccess: () => this.$root.$emit("challengeRequestReviewed", "denied"),
                preserveScroll: true,
            })
        },
        toggleVerificationPhotoSize() {
            this.verificationPhotoExpanded = !this.verificationPhotoExpanded
        },
    },
}
</script>
